/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  function initValuePropositionSection(section) {
    var $section = $(section);

    if (window.innerWidth > 799) {
      var $headline = $section.find('.value-proposition-headline');
      if ($headline.length) {
        ScrollReveal().reveal($headline[0], {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 0,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          once: true
        });
      }

      var cards = $section.find('.value-proposition__card').toArray();
      if (cards.length) {
        ScrollReveal().reveal(cards, {
          origin: 'bottom',
          distance: '20px',
          duration: 700,
          delay: 0,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          opacity: 0,
          scale: 1,
          interval: 40,
          once: true
        });
      }
    }

    if ($(window).width() > 799) return;

    $section.find('.value-proposition__header').on('click', function () {
      var $card = $(this).closest('.value-proposition__card');
      var $text = $card.find('.value-proposition__text');
      var $chevron = $card.find('.value-proposition__chevron');
      $text.slideToggle(300);
      $chevron.toggleClass('is-open');
    });
  }

  function initAllValuePropositionSections() {
    document.querySelectorAll('.value-proposition').forEach(function (section) {
      if (section.dataset.vpInit) return;
      section.dataset.vpInit = 'true';
      initValuePropositionSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllValuePropositionSections);
  } else {
    initAllValuePropositionSections();
  }

  // Re-init on Shopify theme-editor section re-render (fresh DOM node each time).
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.classList && event.target.classList.contains('value-proposition')
      ? event.target
      : event.target.querySelector && event.target.querySelector('.value-proposition');
    if (section) {
      delete section.dataset.vpInit;
      initValuePropositionSection(section);
      section.dataset.vpInit = 'true';
    }
  });
})();